import React from 'react'
import { Link as RouterLink, useHistory } from 'react-router-dom'
import Box from '@material-ui/core/Box'
import Button from '@material-ui/core/Button'
import LinearProgress from '@material-ui/core/LinearProgress'
import Typography from '@material-ui/core/Typography'
import SectionTitle from 'components/section-title'
import { DateTime } from 'luxon'
import PeopleOutlineOutlinedIcon from 'components/material-symbol/icons/PeopleOutline'
import MessageOutlinedIcon from 'components/material-symbol/icons/Message'
import { TonalButton } from 'components/empty-page-state'
import StreamSendMessageButton from 'components/stream-messaging/send-message-button'
import { useGetLeads } from 'pages/pga-coach/leads/api-hooks'
import useStyles from './styles'

const LEAD_LIMIT = 4

const formatLeadIntent = intent =>
  intent.replace(/\s,/g, '').replace(/^,\s/g, '')

const RecentLeads = () => {
  const classes = useStyles()
  const history = useHistory()
  const { data, loading } = useGetLeads()

  const leads = [...(data?.coachingInquiries || [])]
    .sort(
      (a, b) =>
        DateTime.fromISO(b.createdAt).toMillis() -
        DateTime.fromISO(a.createdAt).toMillis(),
    )
    .slice(0, LEAD_LIMIT)

  return (
    <Box className={classes.card}>
      <Box className={classes.cardHeader}>
        <Box className={classes.cardHeaderLeft}>
          <Box className={classes.iconCircle}>
            <PeopleOutlineOutlinedIcon />
          </Box>
          <SectionTitle className={classes.cardTitle}>
            Recent leads
          </SectionTitle>
        </Box>
        <Button
          component={RouterLink}
          to="/pga-coach/leads"
          className={classes.cardAction}
        >
          View all
        </Button>
      </Box>

      {loading && !data ? (
        <LinearProgress color="primary" className={classes.loading} />
      ) : leads.length > 0 ? (
        <Box className={classes.list}>
          {leads.map(lead => {
            const isUnread = !lead.viewedAt
            const isAwaitingReply = !lead.contactedAt
            const ReplyButton = isAwaitingReply ? Button : TonalButton

            return (
              <Box
                key={lead.id}
                className={classes.row}
                onClick={() => history.push(`/pga-coach/leads/${lead.id}`)}
                role="button"
                tabIndex={0}
                onKeyDown={event => {
                  if (event.key === 'Enter' || event.key === ' ') {
                    event.preventDefault()
                    history.push(`/pga-coach/leads/${lead.id}`)
                  }
                }}
              >
                <Box className={classes.rowMain}>
                  <Typography className={classes.rowName}>
                    {lead.contact.firstName} {lead.contact.lastName}
                    {isUnread ? (
                      <span className={classes.unreadDot} aria-hidden />
                    ) : null}
                  </Typography>
                  <Typography className={classes.rowMeta}>
                    {formatLeadIntent(lead.intent)}
                  </Typography>
                </Box>
                <Box className={classes.rowTrailing}>
                  <StreamSendMessageButton
                    userIds={[lead.contact.externalId]}
                    component={ReplyButton}
                    variant="contained"
                    color={isAwaitingReply ? 'primary' : undefined}
                    size="small"
                    className={classes.replyButton}
                    startIcon={<MessageOutlinedIcon />}
                    onClick={event => event.stopPropagation()}
                  >
                    Reply
                  </StreamSendMessageButton>
                </Box>
              </Box>
            )
          })}
        </Box>
      ) : (
        <Typography className={classes.emptyList}>No recent leads.</Typography>
      )}
    </Box>
  )
}

export default RecentLeads
